import ExcelJS from 'exceljs';

const csvPlugin = {
  install(app) {
    app.config.globalProperties.$ExcelJS = ExcelJS;

    app.config.globalProperties.$exportTableToCSV = function (data, filename) {
      const workbook = new ExcelJS.Workbook();

      // Add a worksheet
      const worksheet = workbook.addWorksheet('Sheet 1');
      
      // Add data to the worksheet
      data.forEach((rowData) => {
        worksheet.addRow(rowData);
      });
      // Save the workbook to a file
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        // Create a link to trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = filename + '.csv'; // Set the desired filename
        a.click();

        // Clean up by revoking the Blob URL
        URL.revokeObjectURL(url);
      });
    };
  },
};

export default csvPlugin;
